// src/components/AdminLayout.js
import React from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import Sidebar from './Sidebar';
import Modal from './Modal';
import Login from './auth/Login';
import Register from './auth/Register';
import SelectedProgramHeader from './SelectedProgramHeader';
import '../styles/AdminLayout.css';

const AdminLayout = ({
    children,
    isAuthenticated,
    onLogout,
    isModalOpen,
    modalContent,
    openModal,
    closeModal,
    onLoginSuccess
 }) => {

  console.log("AdminLayout: Received openModal prop:", typeof openModal);
  const location = useLocation(); // Get current location

  // Define paths where the SelectedProgramHeader should NOT be displayed
  const noProgramHeaderPaths = [
    '/dashboard',
    '/setup-program',
    '/select-program'
    // Add any other paths here, e.g., '/admin-profile' if that page doesn't need it
  ];

  // Determine if the header should be shown
  const showProgramHeader = isAuthenticated && !noProgramHeaderPaths.includes(location.pathname);

  return (
    <div className="admin-layout">
      <Sidebar />
      <main className="admin-content">
        <header className="admin-header">
          {isAuthenticated ? (
            <button className="logout-btn" onClick={onLogout}>
              Logout
            </button>
          ) : (
            <button className="login-btn" onClick={() => openModal('login')}>
              Login / Register
            </button>
          )}
        </header>

        {/* Conditionally render SelectedProgramHeader */}
        {showProgramHeader && <SelectedProgramHeader />}

        {children}
      </main>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {modalContent === 'login' && (
          <Login
            openModal={openModal}
            onLoginSuccess={onLoginSuccess}
          />
        )}
        {modalContent === 'register' && (
          <Register
            openModal={openModal}
          />
        )}
      </Modal>
    </div>
  );
};

export default AdminLayout;